import { Auth } from 'aws-amplify';

export async function getIdToken(): Promise<string> {
  const currentSession = await Auth.currentSession();
  const idToken = currentSession.getIdToken().getJwtToken();
  return idToken;
}
